import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Spinner,
  Container,
  Input,
  FormGroup,
  Label,
  Button,
} from "reactstrap";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa"; // 🔹 Import ikon Envelope
import "./InternshipApplicants.css";
import * as XLSX from "xlsx";

const API_URL = "https://app.rlagency.id/api_internship/internship_applicants.php";
const BATCH_API = "https://app.rlagency.id/api_internship/get_batches.php";

const ITEMS_PER_PAGE = 15;

const InternshipApplicants = () => {
  const [applicants, setApplicants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchBatches();
    fetchApplicants();
  }, []);

  const fetchBatches = async () => {
    try {
      const response = await axios.get(BATCH_API);
      if (Array.isArray(response.data)) {
        setBatches(response.data);
      }
    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };

  const fetchApplicants = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL, {
        params: {
          batch: selectedBatch,
          start_date: startDate,
          end_date: endDate,
        },
      });
      setApplicants(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching applicants:", error);
    }
    setLoading(false);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(applicants.length / ITEMS_PER_PAGE);
  const displayedApplicants = applicants.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const exportToExcel = () => {
    if (applicants.length === 0) {
      alert("Tidak ada data untuk diekspor.");
      return;
    }
  
    const formatPhoneNumber = (phone) => {
      if (!phone) return "-";
      phone = phone.trim();
      
      // Jika sudah dalam format +62, langsung kembalikan
      if (phone.startsWith("+62")) {
        return phone;
      }
  
      // Jika nomor diawali dengan 62 tanpa +, tambahkan +
      if (phone.startsWith("62")) {
        return `+${phone}`;
      }
  
      // Jika nomor diawali dengan 0, ubah ke +62
      if (phone.startsWith("0")) {
        return `+62${phone.slice(1)}`;
      }
  
      // Jika formatnya tidak dikenali, kembalikan apa adanya
      return phone;
    };
  
    const dataToExport = applicants.map((applicant, index) => ({
      No: index + 1,
      Batch: applicant.batch || "-",
      Nama: applicant.full_name,
      Email: applicant.email,
      "No HP": formatPhoneNumber(applicant.phone), // 🔹 Format nomor HP
      Universitas: applicant.university,
      Jurusan: applicant.major,
      Status: applicant.status,
      "Semester/Tanggal Lulus":
        applicant.status === "kuliah"
          ? `Semester ${applicant.semester}`
          : applicant.graduation_date
          ? new Date(applicant.graduation_date).toLocaleDateString("id-ID", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })
          : "-",
      Posisi: applicant.position || "-",
      "Link CV": `https://app.rlagency.id/api_internship/${applicant.cv_path}`,
      "Link Portofolio": applicant.portfolio || "-",
      "Waktu Pendaftaran": new Date(applicant.created_at).toLocaleDateString(
        "id-ID",
        { day: "numeric", month: "short", year: "numeric" }
      ),
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Applicants");
  
    XLSX.writeFile(workbook, "Internship_Applicants.xlsx");
  };   

  return (
    <Container>
      <h2>Internship Applicants</h2>

      {/* FILTER */}
      <div className="filters">
        <FormGroup>
          <Label>Pilih Batch</Label>
          <Input type="select" value={selectedBatch} onChange={(e) => setSelectedBatch(e.target.value)}>
            <option value="">Semua Batch</option>
            {batches.map((batch, index) => (
              <option key={index} value={batch}>{batch}</option>
            ))}
          </Input>
        </FormGroup>

        {/* <FormGroup>
          <Label>Rentang Waktu Pendaftaran</Label>
          <div className="date-filter">
            <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            <span className="date-separator">s/d</span>
            <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </div>
        </FormGroup> */}
        
        <Button className="btn-filter" onClick={fetchApplicants}>Terapkan Filter</Button>
        <Button className="btn-filter" onClick={exportToExcel}>Download Excel</Button>  

      </div>

      {/* TABEL */}
      {loading ? (
        <div className="text-center my-4"><Spinner color="primary" /></div>
      ) : (
        <>
          <Table bordered className="applicants-table">
            <thead>
              <tr>
                <th>No</th>
                <th>Batch</th>
                <th>Nama</th>
                <th>Email</th>
                <th>WA</th>
                <th>Universitas</th>
                <th>Jurusan</th>
                <th>Status</th>
                <th>Semester/Tgl Lulus</th>
                <th>Posisi</th>
                <th>CV</th>
                <th>Portofolio</th>
                <th>Waktu Pendaftaran</th>
              </tr>
            </thead>
            <tbody>
              {displayedApplicants.length > 0 ? (
                displayedApplicants.map((applicant, index) => (
                  <tr key={applicant.id}>
                    <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                    <td>{applicant.batch || "-"}</td>
                    <td>{applicant.full_name}</td>
                    <td>
                      {/* 🔹 Ganti email dengan ikon envelope */}
                      <a href={`mailto:${applicant.email}`}>
                        <FaEnvelope size={18} color="#007bff" />
                      </a>
                    </td>
                    <td>
                      <a href={`https://wa.me/${applicant.phone}`} target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp size={20} color="#25d366" />
                      </a>
                    </td>
                    <td>{applicant.university}</td>
                    <td>{applicant.major}</td>
                    <td>{applicant.status}</td>
                    <td>
                      {applicant.status === "kuliah"
                        ? `Semester ${applicant.semester}`
                        : applicant.graduation_date
                          ? new Date(applicant.graduation_date).toLocaleDateString("id-ID", {
                              day: "numeric", month: "short", year: "numeric"
                            })
                          : "-"}
                    </td>
                    <td>{applicant.position || "-"}</td>
                    <td>
                      <a href={`https://app.rlagency.id/api_internship/${applicant.cv_path}`} target="_blank" rel="noopener noreferrer">
                        Lihat CV
                      </a>
                    </td>
                    <td>
                      {applicant.portfolio ? (
                        <a href={applicant.portfolio} target="_blank" rel="noopener noreferrer">Lihat Portofolio</a>
                      ) : "-"}
                    </td>
                    <td>
                      {new Date(applicant.created_at).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" })}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="text-center">Tidak ada data pendaftar</td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* PAGINATION */}
          <div className="pagination">
            <Button onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>Prev</Button>
            <span> Halaman {currentPage} dari {totalPages} </span>
            <Button onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>Next</Button>
          </div>
        </>
      )}
    </Container>
  );
};

export default InternshipApplicants;
